import {css} from "lit";
import {commonStyles} from "../../common/styles/Common.js";
import {customScrollStyles} from "../../common/styles/CustomScrollBar.js";
import {iconStyles} from "../../common/styles/Icons.js";

export const citationPanelStyles = [commonStyles, customScrollStyles, iconStyles, css`
	#citation-container {
		display: flex;
		flex-direction: column;
		height: calc(100vh);
		overflow-y: auto;
		padding-top: 10px;
	}

	#citation-container.citation-info-selected #btn-citation-info,
	#citation-container.citation-notes-selected #btn-citation-notes {
		border-bottom: 2px solid var(--pn-color-black);
	}

	pn-citation-information, pn-citation-notes {
		display: none;
	}

	#citation-container.citation-info-selected #citation-content pn-citation-information,
	#citation-container.citation-notes-selected #citation-content pn-citation-notes {
		display: block;
	}

	#tab-buttons {
		display: flex;
		justify-content: flex-start;
		border-bottom: 1px solid lightgray;
	}

	#tab-buttons button, #tab-buttons a {
		font-family: var(--pn-headings-font-family);
		font-weight: 500;
		font-size: 16px;
		background-color: transparent;
		border: none;
		padding: 10px 5px;
		cursor: pointer;
	}

	#tab-buttons a {
		margin: auto 15px auto auto;
		font-size: var(--pn-font-size-base);
	}

	/** Matches icon button styles for ProQuest integration **/
	#tab-buttons .btn-go-to-source {
		border-radius: 6px;
		padding: 8px;
	}

	/** Matches icon button styles for ProQuest integration **/
	#tab-buttons .__pq-int__.btn-go-to-source:hover,
	#tab-buttons .__pq-int__.btn-go-to-source:focus {
		background-color: #cececf;
	}

	/* Collapse when sidebar is narrow, such as in the case of integrations
	like ProQuest that can cause the sidebar to be very narrow */
	.tab-spacer {
		flex: 0 1 30px;
	}

	div.citation-disclaimer {
		font-weight: 500;
		color: var(--pn-sidebar-citation-field-label-color);
		font-size: 12px;
		line-height: 17px;
		padding: 30px 50px 0 30px;
	}

	.citation-update-all-missing {
		color: var(--pn-sidebar-citation-field-label-color);
		font-size: 12px;
		line-height: 17px;
		padding: 30px 50px 0 30px;
	}

	.citation-update-all-missing a {
		color: var(--pn-sidebar-citation-field-label-color);
	}

	#citation-content {
		flex: 1;
		padding: 30px 28px 0px;
		overflow-y: auto;
	}

	#citation-button-group {
		display: flex;
		justify-content: space-evenly;
		margin: 25px 28px 85px;
	}
`];
